export const WarningMessages = {
	WaterfallErrorMessage:
		"Total Residual Split % for all entities must equal 100%",
	OverrideErrorMessage: "Residual split % must not equal more than 100%",
	IncorrectOverrideTotalAmount:
		"Split %'s cannot total more or less than total revenue share %",
	DuplicateAgentErrorMessage:
		"Agent is already selected as primary or secondary split.",
	WaterfallSplit100PercentWarningMessage:
		"If any agent gets 100% split then next added agents will have 0 split by default without ability to edit it unless previous 100% is edited to a lower value",
	ReassignHighRiskWarningMessage: `Agent has only one NON-high risk Split Profile.\nThis parameter is required for the merchant onboarding process.\nPlease create a new Split Profile to change the default.`,
};

export const ExampleCalculationValue = 1000;

export const ResidualsUserRole = "Residuals User";
